import { delay, HttpResponse } from "msw";

export const postFeedback = async () => {
  await delay("real");
  return HttpResponse.json({ response: "0dfc80a9-8a9a-4aaa-8961-c9467c7a6f3a" });
};
